import { useState } from 'react';
import { PortalUser } from 'vopay';
import { api } from '@/services/api.config';

export default function useFetchAuthorizedIpAddresses() {
  const [fetchingAuthorizedIps, setFetchingAuthorizedIps] = useState(false);
  const [authorizedIps, setAuthorizedIps] = useState<string>();

  async function fetchAuthorizedIps(params: PortalUser) {
    try {
      setFetchingAuthorizedIps(true);
      const res = await api.fetchAuthorizedIPs(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setAuthorizedIps(res.AuthorizedIPs);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingAuthorizedIps(false);
    }
  }

  return { fetchingAuthorizedIps, authorizedIps, fetchAuthorizedIps };
}
